/* eslint-disable jsx-a11y/media-has-caption */
// import { useRouter } from 'next/router'
// import { useSession } from 'next-auth/react'
import useTranslation from 'next-translate/useTranslation'
import { useCallback, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast, ToastContainer } from 'react-toastify'
import Webcam from 'react-webcam'

import api from '@/lib/api'
import { NAMESPACE_IDENTIFICATION_PAGE } from '@/res/namespaces'
// import { toBase64 } from '@/utils/fileToBase64'
// import { ROUTE_PROFILE } from '@/res/routes'

const videoConstraints = {
  with: 540,
  facingMode: 'enviroment',
}
interface FormValues {
  serial_number: string
  birth_date: string
}

const WebIdentificationForm: React.FC = () => {
  const { t } = useTranslation(NAMESPACE_IDENTIFICATION_PAGE)
  // const router = useRouter()
  // const { data } = useSession()
  const notifySucces = () => toast.success(t('identification_data_sended'))
  const notifyError = (err?: string) => {
    toast.error(err || t('identification_data_error'))
  }
  const [isCaptureEnable, setCaptureEnable] = useState<boolean>(false)
  const webcamRef = useRef<any>(null)
  const [photo_base64, setPhoto_base64] = useState<any>(null)
  // console.log(photo_base64)
  const [webErrors, setWebErrors] = useState<boolean>(true)
  // const [passport, setPassport] = useState<string>('')
  // const [birth, setBirth] = useState<string>('')
  const capturePhoto = useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot()
    setPhoto_base64(imageSrc)
  }, [webcamRef])

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onChange',
  })

  const onSubmit = async ({ serial_number, birth_date }: FormValues) => {
    try {
      const formData = {
        serial_number: serial_number,
        birth_date: birth_date,
        photo_base64: photo_base64,
      }
      // console.log(formData)
      // console.log(photo_base64.split(',')[1])
      const { data } = await api.post(
        'http://localhost:3000/api/face',
        formData
      )
      notifySucces()
      // router.push(ROUTE_PROFILE)
      return data
    } catch (err: any) {
      notifyError(err?.response?.data?.msg || undefined)
      return err
    }
  }
  const onUserMediaError = () => {
    setWebErrors(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ToastContainer />
      <div className="mt-8 mb-16 text-center text-2xl">
        {t('passport_texts')}
      </div>
      <div className="flex  mb-10">
        <div className="w-1/2 lg:text-lg md:text-[20px] ">
          {' '}
          {t('passport_number')}
        </div>

        <div className="flex flex-col">
          <input
            placeholder={t('serial_number')}
            className={`border pl-2 dark:bg-slate-600 dark:border-slate-500 border-gray-400 h-10 rounded focus:outline-none w-1/2 ${
              errors.serial_number && 'focus:ring-red-500 border-red-500'
            }`}
            {...register('serial_number', {
              required: 'passport is required',
              pattern: {
                value: /([A-Z]+[0-9])/,
                message: t('passport_valid'),
              },
              maxLength: 9,
            })}
          />
          {errors.serial_number && (
            <span className="text-sm text-red-500">
              {errors.serial_number.message as string}
            </span>
          )}
        </div>
      </div>
      <div className="flex ">
        <div className="w-1/2 lg:text-lg md:text-[20px] ">{t('data')}</div>
        <input
          type="date"
          {...register('birth_date', {
            required: 'birth is required',
          })}
          className=" p-2 text-base border-[1px] outline-none border-[#d3e8f7] focus:border-primary rounded-lg  placeholder:font-normal placeholder:text-base"
        />
      </div>
      <div className=" mt-5 flex items-center ">
        <div className="lg:text-lg md:text-[20px]   w-1/2 ">{t('selfie')}</div>

        <div className="pt-5" style={{ textAlign: 'center' }}>
          {isCaptureEnable || (
            <button
              className="bg-primary"
              type="button"
              style={{
                cursor: 'pointer',
                color: 'white',
                paddingLeft: '20px',
                paddingRight: '20px',
                fontSize: '23px',
                border: 'none',
                borderRadius: '10px',
              }}
              onClick={() => setCaptureEnable(true)}
            >
              {t('start')}
            </button>
          )}

          {isCaptureEnable && (
            <>
              {' '}
              {webErrors ? (
                <div>
                  <div>
                    <button
                      className="bg-primary"
                      type="button"
                      style={{
                        cursor: 'pointer',
                        color: 'white',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                        fontSize: '23px',
                        border: 'none',
                        borderRadius: '10px',
                      }}
                      onClick={() => setCaptureEnable(false)}
                    >
                      {t('end')}
                    </button>
                  </div>

                  <div>
                    <div>
                      <Webcam
                        ref={webcamRef}
                        audio={false}
                        screenshotFormat="image/jpeg"
                        videoConstraints={videoConstraints}
                        onUserMediaError={onUserMediaError}
                      />
                    </div>
                    <div className="flex justify-between mt-10 gap-5">
                      <button
                        className="bg-green-600 rounded-xl w-1/2"
                        type="button"
                        onClick={capturePhoto}
                      >
                        {t('screen')}
                      </button>
                      <button
                        className="bg-yellow-400 rounded-xl w-1/2"
                        type="button"
                        onClick={() => setPhoto_base64(null)}
                      >
                        {t('refresh')}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                t('dont_camera')
              )}
            </>
          )}
          {photo_base64 && (
            <div>
              <img src={photo_base64} alt="Screenshot" />
            </div>
          )}
        </div>
      </div>
      {photo_base64 && (
        <div>
          <img src={photo_base64} alt="Screenshot" />
        </div>
      ) ? (
        <div className="flex justify-center pt-24 items-center ">
          <button
            className="bg-primary"
            type="submit"
            style={{
              cursor: 'pointer',
              color: 'white',
              paddingLeft: '10px',
              paddingRight: '10px',
              fontSize: '25px',
              border: 'none',
              borderRadius: '10px',
            }}
          >
            Отправить
          </button>
        </div>
      ) : null}
      {/* <button
        className="bg-primary"
        type="submit"
        style={{
          cursor: 'pointer',
          color: 'white',
          paddingLeft: '10px',
          paddingRight: '10px',
          fontSize: '25px',
          border: 'none',
          borderRadius: '10px',
        }}
      >
        Отправить
      </button> */}
    </form>
  )
}

export default WebIdentificationForm
